import { createGlobalStyle } from 'styled-components'
import { SCREENSHOT_GUARD_ACTIVE_CLASS } from 'utils/screenshotGuard'
import './font.css'

const globalStyle = createGlobalStyle`
  html {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  }

  html,
  body,
  #root {
    width: 100%;
    height: 100%;
    display: flex;
    background-color:#FFF;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  }

  .hide {
    display: none!important;
  }

  .invisible {
    visibility: hidden!important;
    pointer-events: none!important;
  }  

  .full-width {
    width: 100%;    
  }

  .flex {
    display: flex;
  }

  .flex-1 {
    flex: 1;
  }

  .overflow-y {
    overflow-y: auto;
  }

  .text-center {
    text-align: center!important;
  }

  .p-padding-bottom-1 {
    padding-bottom: 10px!important;
  }

  .p-padding-bottom-2 {
    padding-bottom: 20px!important;
  }

  .p-margin-top-1 {
    margin-top: 10px!important;
  }

  .p-margin-top-2 {
    margin-top: 20px!important;
  }

  .p-margin-bottom-1 {
    margin-bottom: 10px!important;
  }

  .p-margin-bottom-2 {
    margin-bottom: 20px!important;
  }

  mark.article-find-match {
    background: #ffeb3b;
    padding: 0 2px;
    border-radius: 2px;
  }

  mark.article-find-active {
    background: #ff9800;
    outline: 2px solid #f57c00;
  }

  @media print {
    html.${SCREENSHOT_GUARD_ACTIVE_CLASS},
    html.${SCREENSHOT_GUARD_ACTIVE_CLASS} body,
    html.${SCREENSHOT_GUARD_ACTIVE_CLASS} #root {
      display: none;
    }
  }
`

export default globalStyle
